const showKlarnaNotification = (
    klarnaMarketThreshold,
    klarnaMarkets,
    commerceMarket,
    commerceMarketSupportsEcom,
    unitPrice,
    quantity
) => {
    if (!klarnaMarketThreshold) {
        return false;
    }
    if (!klarnaMarkets) {
        return false;
    }
    if (!commerceMarket) {
        return false;
    }
    if (!commerceMarketSupportsEcom)
        return false;

    let markets = klarnaMarkets.split(',');
    if(!markets?.includes(commerceMarket))
        return false;

    if (!unitPrice || !quantity) {
        return false;
    }

    let thresholdForMarket = JSON.parse(klarnaMarketThreshold)[commerceMarket.toLowerCase()];
    if (!thresholdForMarket) {
        return false;
    }

    if ((unitPrice * quantity) >= thresholdForMarket) {
        return false;
    }

    return true;
}

export default showKlarnaNotification;